const students = 'Estudiantes'
const event = 'Fiesta'
const travel = 'viaje'
const registered = 'registrados'
const total = 'total'
const movementDetails = 'Detalle de movimientos'
const projected = 'Proyectados'
const individualGoal = 'Meta individual'

export const individualTravelGoalText = `${individualGoal} ${travel.toUpperCase()}`
export const individualEventGoalText = `${individualGoal} ${event.toUpperCase()}`
export const individualTotalGoalText = `${individualGoal} ${total.toUpperCase()}`
export const projectedNumberStudentsTravelText = `Nro. ${students} ${projected} ${travel.toUpperCase()}`
export const projectedNumberStudentsEventText = `Nro. ${students} ${projected} ${event.toUpperCase()}`
export const realNumberStudentsTravelText = `Nro. ${students} Reales ${registered.toUpperCase()}`
export const descriptionText = 'Descripción'
export const dateText = 'Fecha'
export const mountText = 'Monto'
export const providerText = 'Proveedor'
export const totalEstimatedGoalText = 'Meta Total Proyectada de la Promoción'
export const realCurrentSavingsText = 'Ahorro Actual Real de la Promoción'
export const savingsAdvancePercentageText = 'Porcentaje de Avance de Ahorro'
export const performanceText = 'Rendimiento Real de la Promoción'
export const displayRepresentativesText = 'Visualización representantes'

export const savingsEndDateText = 'Fecha de finalización de ahorro:'
export const projectedIndividualGoalsText = 'Metas individuales Proyectadas'
export const promotionGeneralInformationText = 'Información general de la promoción'
export const projectedStudents = `${students} proyectados`
export const realRegisteredStudents = `${students} reales registrados`
export const totalAdditionalSavingsText = 'Ahorro adicional total'
export const detailTotalEventMovementsText = `${movementDetails}  ${total}`
export const activeText = 'Activar'
export const hideText = 'Ocultar'
export const youCanEnableOrDisableTheDisplayText =
  'Puedes activar o desactivar la visualización de esta sección para los representes'
export const uploadTheStudentSatabaseText =
  'Cargar la base de datos de los estudiantes en el formato establecido'
